export default __webpack_public_path__ + "static/media/640_dummy2016-eventagentur01-de.888c5733.png";